import './Loader.scss';

import Loader from './Loader';
import cn from 'classnames';

interface Props {
  isLoading: boolean;
  className?: string;
  children?: JSX.Element | string;
}

const LoaderComponent = (props: Props) => {
  return (
    <div className={cn(props.isLoading ? 'wrapper' : '')}>
      <span>{props.children}</span>
      <div className="loader-wrapper">
        <Loader className={props.className} />
      </div>
    </div>
  );
};

LoaderComponent.defaultProps = {
  className: ''
};

export default LoaderComponent;
